export const fadeUp = {
  initial: { opacity: 0, y: 14 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export const fadeUpAt = (i, step = 0.07, duration = 0.5) => ({
  ...fadeUp,
  transition: { duration, delay: i * step },
});
